import * as S from './styles';
import { useState, useEffect } from 'react';
import NoClassSectionData from './NoClassSectionData';
import { getProfessorClassSection } from 'apis/main';
import useUser from 'store/user/useUser';
import ClassCard from './ClassCard';
import { ClassSection } from './type';
import Modal from './Modal';

export default function ClassSectionManagement() {
  const [classSections, setClassSections] = useState<ClassSection[]>([]);
  const [modalType, setModalType] = useState<string>('');
  const [selectedSection, setSelectedSection] = useState<ClassSection | null>(
    null
  );
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { student_uuid, student_college } = useUser();

  const fetchData = async () => {
    const res = await getProfessorClassSection(student_uuid);
    const userSections = res.data.class_section_list || [];
    setClassSections(userSections);
  };

  useEffect(() => {
    fetchData();
  }, [student_uuid]);

  const handleUpdate = (sectionId: number) => {
    const section = classSections.find(
      item => item.class_section_id === sectionId
    );
    setSelectedSection(section || null);
    setModalType('update');
    setIsModalOpen(true);
  };

  const handleDelete = (sectionId: number) => {
    const section = classSections.find(
      item => item.class_section_id === sectionId
    );
    setSelectedSection(section || null);
    setModalType('delete');
    setIsModalOpen(true);
  };

  const onCreate = () => {
    setSelectedSection(null);
    setModalType('create');
    setIsModalOpen(true);
  };

  const onClose = () => {
    setIsModalOpen(false);
    setModalType('');
    setSelectedSection(null);
    fetchData();
  };

  return (
    <S.Container>
      <S.ContentWrapper>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '24px',
          }}
        >
          <S.Title>우리학교 분반 생성 및 관리</S.Title>
          <S.CreateButton onClick={onCreate}>+ 분반 만들기</S.CreateButton>
        </div>
        {classSections.length > 0 ? (
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
          >
            {classSections.map((item: ClassSection) => (
              <ClassCard
                key={item.class_section_id}
                item={item}
                onUpdate={handleUpdate}
                onDelete={handleDelete}
              />
            ))}
          </div>
        ) : (
          <NoClassSectionData />
        )}
      </S.ContentWrapper>

      {isModalOpen && (
        <Modal
          open={isModalOpen}
          userId={student_uuid}
          collegeId={student_college}
          onClose={onClose}
          modalType={modalType}
          sectionId={selectedSection?.class_section_id || 0}
          initialData={selectedSection}
        />
      )}
    </S.Container>
  );
}
